export class TrackerData {
    constructor(
        public analyticType: any,
        public action?: string,
        public label?: any) { }
}
